import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import ServiceCooperative from './pages/ServiceCooperative'
import ServiceMicroLending from './pages/ServiceMicroLending'
import ServiceTaxConsulting from './pages/ServiceTaxConsulting'
import ServiceFinancialReporting from './pages/ServiceFinancialReporting'
import Clients from './pages/Clients'
import FAQs from './pages/FAQs'
import Contact from './pages/Contact'

function ScrollToTop() {
    const { pathname } = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])
    return null
}

function App() {
    const location = useLocation()

    useEffect(() => {
        // Re-initialize jQuery plugins after route change
        const timer = setTimeout(() => {
            if (window.jQuery) {
                // Re-initialize WOW.js
                if (window.WOW) {
                    new window.WOW().init()
                }
                // Re-initialize slicknav
                const $ = window.jQuery
                if ($.fn.slicknav) {
                    $('#menu').slicknav({
                        prependTo: '.responsive-menu',
                        allowParentLinks: true,
                        label: '',
                    })
                }
                // Re-initialize counterUp
                if ($.fn.counterUp) {
                    $('.counter').counterUp({ delay: 10, time: 2000 })
                }
                // Re-initialize magnific popup
                if ($.fn.magnificPopup) {
                    $('.popup-video').magnificPopup({ type: 'iframe' })
                }

                // Re-initialize GSAP reveal animations
                if (window.gsap && window.ScrollTrigger) {
                    const gsap = window.gsap
                    gsap.registerPlugin(window.ScrollTrigger)
                    const revealContainers =
                        document.querySelectorAll('.reveal')
                    revealContainers.forEach((container) => {
                        let image = container.querySelector('img')
                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: container,
                                toggleActions: 'play none none none',
                            },
                        })
                        tl.set(container, { autoAlpha: 1 })
                        tl.from(container, 1, {
                            xPercent: -100,
                            ease: 'power2.out',
                        })
                        tl.from(image, 1, {
                            xPercent: 100,
                            scale: 1,
                            delay: -1,
                            ease: 'power2.out',
                        })
                    })
                }

                // Re-initialize GSAP text animations
                if (window.gsap && window.SplitText) {
                    const gsap = window.gsap

                    document
                        .querySelectorAll('.text-anime-style-2')
                        .forEach((element) => {
                            let animationSplitText = new window.SplitText(
                                element,
                                { type: 'chars, words' }
                            )
                            gsap.from(animationSplitText.chars, {
                                duration: 1,
                                delay: 0.5,
                                x: 0,
                                autoAlpha: 0,
                                stagger: 0.05,
                                scrollTrigger: {
                                    trigger: element,
                                    start: 'top 85%',
                                },
                            })
                        })
                }
            }
        }, 300)
        return () => clearTimeout(timer)
    }, [location.pathname])

    return (
        <div className="App">
            <ScrollToTop />
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route
                    path="/service-cooperative"
                    element={<ServiceCooperative />}
                />
                <Route
                    path="/service-micro-lending"
                    element={<ServiceMicroLending />}
                />
                <Route
                    path="/service-tax-consulting"
                    element={<ServiceTaxConsulting />}
                />
                <Route
                    path="/service-financial-reporting"
                    element={<ServiceFinancialReporting />}
                />
                <Route path="/clients" element={<Clients />} />
                <Route path="/faqs" element={<FAQs />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
        </div>
    )
}

export default App
